module.exports = __webpack_public_path__ + "assets/6160b6f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/header/euronics.png
// module id = 89
// module chunks = 0